import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { createRoot, Root } from 'react-dom/client';
import { createElement } from 'react';
import { MainLoader } from '@frontend/profilum-components';
import { mainLoaderStore } from '@pflm-shared';

@Component({
  selector: 'prf-loader-react',
  standalone: true,
  imports: [],
  templateUrl: './loader-react.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderReactComponent implements AfterViewInit {
  @ViewChild('loader') loaderRef: ElementRef;
  private root: Root;

  public ngAfterViewInit() {
    this.root = createRoot(this.loaderRef.nativeElement);
    this.root.render(createElement(MainLoader, { store: mainLoaderStore }));
  }

  public ngOnDestroy() {
    this.root.unmount();
  }
}
